import { connect } from 'react-redux';

import ViziaComponent from '../components/ViziaComponent';
import {
  getConfig,
  getComponentById,
  getFolderByComponentId,
  getOtp,
} from '../selectors/index.js';
import {
  setComponentFocus
} from '../actions/ui';

const mapStateToProps = (state, props) => {
  return {
    folderOptions: getFolderByComponentId(state, props).options,
    config: getConfig(state),
    colors: state.colors,
    otp: getOtp(state),
    isFocussed: state.ui.componentFocusId === props.id,
    uiMode: state.ui.mode,
    ...getComponentById(state, props)
  };
};

const mapDispatchToProps = {
  setComponentFocus
};

export default connect(mapStateToProps, mapDispatchToProps)(ViziaComponent);
